import { CtrlType } from "@yuigoto/ctrl";

export const ProductReviewControl = [
  {
    label: "Apelido",
    name: "nickname",
    required: true
  },
  {
    label: "Título",
    name: "title",
    required: true
  },
  {
    label: "Comentário",
    name: "review",
    required: true,
    type: CtrlType.TEXTAREA,
    minLength: 30,
    minLengthMessage: "Mínimo de 30 caracteres."
  },
];
